/**
 * demo-picker.js
 *
 * Drives the "Schedule a demo" region popover in the contact section.
 * Opens on click/tap only; closes on outside click and Escape. State lives
 * on the panel's `data-open` attribute, which the CSS animates.
 */

document.querySelectorAll('[data-demo-picker]').forEach((picker) => {
  const trigger = picker.querySelector('[data-demo-trigger]');
  const panel = picker.querySelector('[data-demo-panel]');
  if (!trigger || !panel) return;

  const isOpen = () => panel.dataset.open === 'true';

  // Pick the side with room so the menu never clips off-screen. Defaults to
  // below the trigger; flips above only when below can't fit and above has
  // more space. offsetHeight is readable while the panel is visibility:hidden.
  const place = () => {
    const rect = trigger.getBoundingClientRect();
    const margin = 12;
    const spaceBelow = window.innerHeight - rect.bottom - margin;
    const spaceAbove = rect.top - margin;
    const panelHeight = panel.offsetHeight;
    panel.dataset.placement =
      spaceBelow < panelHeight && spaceAbove > spaceBelow ? 'top' : 'bottom';
  };

  const open = () => {
    place();
    panel.dataset.open = 'true';
    trigger.setAttribute('aria-expanded', 'true');
  };

  const close = () => {
    panel.dataset.open = 'false';
    trigger.setAttribute('aria-expanded', 'false');
  };

  // Click / tap toggles open/closed.
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    isOpen() ? close() : open();
  });

  // Escape closes and returns focus to the trigger.
  picker.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      close();
      trigger.focus();
    }
  });

  // Click anywhere outside closes.
  document.addEventListener('click', (e) => {
    if (isOpen() && !picker.contains(e.target)) close();
  });
});
